import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check_purple_icon.svg';
import { getProcessVariables } from "store/adminPanel/actions";
import { getLocalString, localNames } from "utils/localisation.service";

const ActionList = (props) =>{

    const [view, setView] = useState();
    const [edit, setEdit] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        setView(true);
        setEdit(true);  

    }, [])

    const onEdit = (value) => {
        dispatch(getProcessVariables(props.id))
        props.open(false);
        props.showEdit(true);
        props.showView(false);
    }

    const onView = (value) => {
        dispatch(getProcessVariables(props.id))
        props.open(false);
        props.showView(true);
        props.showEdit(false);
    }

    const locales = useSelector(state => state.forms?.localeStrings);
    
    return(
        
        <div className="popover-container">
            { view ? <div className="popover-item" onClick={()=>onView(props.id)}><span>{getLocalString(locales, localNames.REQUEST_PAGE_RESULTTABLE_VIEW)} <CheckIcon className="check"/></span></div>: null } 
            { edit ? <div className="popover-item" onClick={()=>onEdit(props.id)}><span>{getLocalString(locales, localNames.REQUEST_PAGE_RESULTTABLE_EDIT)} <CheckIcon className="check"/></span></div> : null }            
        </div>
    )
}

export default ActionList;